import { AppConfig } from '@/constants/residents/config';

type TokenizeCardParams = {
  account: string; // PAN without spaces
  cvv: string;
  expiry: string; // MMYY
};

type TokenizeAchParams = {
  routingNumber: string;
  accountNumber: string;
};

type CardSecureResponse = {
  token?: string;
  errorcode?: number | string;
  message?: string;
};

const getCardSecureUrl = (): string => {
  const cardConnectUrl = AppConfig.CARDCONNECT.URL;
  
  if (!cardConnectUrl) {
    console.error('CARDCONNECT.URL is not configured');
    throw new Error('Payment gateway configuration error. Please contact support.');
  }
  
  try {
    const url = new URL(cardConnectUrl);
    return `https://${url.host}/cardsecure/api/v1/ccn/tokenize`;
  } catch (error) {
    console.error('Invalid CARDCONNECT.URL:', cardConnectUrl, error);
    throw new Error('Payment gateway configuration error. Please contact support.');
  }
};

export const tokenizeCard = async ({ account, cvv, expiry }: TokenizeCardParams): Promise<string> => {
  const endpoint = getCardSecureUrl();
  const resp: CardSecureResponse = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ account, cvv, expiry }),
    credentials: 'omit',
  }).then((r) => r.json());

  const token = resp?.token;
  const errorcode = Number(resp?.errorcode ?? 0);
  if (!token || errorcode !== 0) {
    const message = resp?.message || 'Card tokenization failed';
    throw new Error(message);
  }
  return token;
};

export const tokenizeAch = async ({ routingNumber, accountNumber }: TokenizeAchParams): Promise<string> => {
  const endpoint = getCardSecureUrl();
  const resp: CardSecureResponse = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // For CardSecure ACH, concatenate routing/account (matches existing code behavior)
    body: JSON.stringify({ account: `${routingNumber}/${accountNumber}` }),
    credentials: 'omit',
  }).then((r) => r.json());

  const token = resp?.token;
  const errorcode = Number(resp?.errorcode ?? 0);
  if (!token || errorcode !== 0) {
    const message = resp?.message || 'ACH tokenization failed';
    throw new Error(message);
  }
  return token;
};


